<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">search</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Movimientos de Usuarios</h1>
    <span *ngIf="users.length > 0" class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full">
      {{ users.length }} registros
    </span>
  </div>
  <span *ngIf="users.length > 0" class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mb-4">
    {{ users.length }} registros
  </span>

  <!-- Card Filtros -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">filter_list</mat-icon>
        Filtros de B&uacute;squeda
      </h2>
    </div>
    <div class="p-5">
      <div class="flex flex-col sm:flex-row gap-4 items-end">
        <mat-form-field appearance="outline" class="w-full sm:w-auto sm:flex-1 modern-field">
          <mat-label>Tipo de b&uacute;squeda</mat-label>
          <mat-select required [(ngModel)]="selectedFilter">
            <mat-option>Seleccione un filtro</mat-option>
            <mat-option *ngFor="let filter of filters" [value]="filter">
              {{ filterDescriptions[filter] }}
            </mat-option>
          </mat-select>
          <mat-icon matPrefix style="color: #6b7280;">tune</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full sm:w-auto sm:flex-1 modern-field">
          <mat-label>Valor de b&uacute;squeda</mat-label>
          <input matInput type="text" [(ngModel)]="searchValue" />
          <mat-icon matPrefix style="color: #6b7280;">person_search</mat-icon>
          <button *ngIf="searchValue" matSuffix type="button" (click)="searchValue = ''"
            style="display: inline-flex; align-items: center; justify-content: center; width: 24px; height: 24px; border: none; border-radius: 50%; background: #f3f4f6; cursor: pointer;"
            onmouseover="this.style.background='#e5e7eb'" onmouseout="this.style.background='#f3f4f6'">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #6b7280;">close</mat-icon>
          </button>
        </mat-form-field>

        <button type="button" (click)="search()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 28px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease; height: 48px; white-space: nowrap;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
          Buscar
        </button>
      </div>
    </div>
  </div>

  <!-- Card Tabla -->
  <div *ngIf="dataSource" class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 16px 24px; border-bottom: 2px solid #93c5fd;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a5f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">table_chart</mat-icon>
        Resultados
      </h2>
    </div>

    <!-- Tabla Desktop -->
    <div class="hidden lg:block overflow-x-auto">
      <table mat-table [dataSource]="dataSource" (matSortChange)="sortData($event)" matSort class="w-full">
        <!-- ID -->
        <ng-container matColumnDef="idUsuario">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 80px;">ID</th>
          <td mat-cell *matCellDef="let row">
            <span class="font-mono text-xs font-bold text-green-800 bg-green-100 px-2 py-0.5 rounded-full">{{ row.usuarioId }}</span>
          </td>
        </ng-container>

        <!-- Nombre -->
        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 200px;">Nombre</th>
          <td mat-cell *matCellDef="let row" class="text-xs">{{ row.nombre }} {{ row.apellidos }}</td>
        </ng-container>

        <!-- Documento -->
        <ng-container matColumnDef="documento">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 140px;">Documento</th>
          <td mat-cell *matCellDef="let row" class="text-xs font-mono">{{ row.numeroId }}</td>
        </ng-container>

        <!-- Email -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 220px;">Email</th>
          <td mat-cell *matCellDef="let row" class="text-xs">{{ row.email }}</td>
        </ng-container>

        <!-- Acciones (admin) -->
        <ng-container matColumnDef="acciones" stickyEnd>
          <th mat-header-cell *matHeaderCellDef style="text-align: center; min-width: 80px;">Ver</th>
          <td mat-cell *matCellDef="let row" style="text-align: center;">
            <button title="Ver movimientos" [routerLink]="[path, row.usuarioId, row.email]"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bbf7d0; border-radius: 6px; background: #f0fdf4; cursor: pointer;"
              onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #16a34a;">visibility</mat-icon>
            </button>
          </td>
        </ng-container>

        <!-- Acciones (cashier) -->
        <ng-container matColumnDef="acciones-cashier" stickyEnd>
          <th mat-header-cell *matHeaderCellDef style="text-align: center; min-width: 100px;">Acciones</th>
          <td mat-cell *matCellDef="let row" style="text-align: center;">
            <div style="display: flex; gap: 4px; justify-content: center;">
              <button title="Ver movimientos" [routerLink]="[path, row.usuarioId, row.email]"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bbf7d0; border-radius: 6px; background: #f0fdf4; cursor: pointer;"
                onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #16a34a;">person_add</mat-icon>
              </button>
              <button title="Intercambiar" [routerLink]="['/retail/exchange', row.email]"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer;"
                onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">currency_exchange</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <!-- Cards Mobile -->
    <div class="lg:hidden p-4 space-y-3">
      <div *ngFor="let row of users; let i = index"
        class="bg-white rounded-xl border transition-all duration-200"
        [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">
        <!-- Card Header -->
        <div class="flex items-center justify-between p-3 cursor-pointer" (click)="toggleCard(i)">
          <div class="flex items-center gap-2 flex-1 min-w-0">
            <span class="inline-block text-xs font-bold px-2 py-0.5 rounded-full bg-green-100 text-green-800 font-mono">#{{ row.usuarioId }}</span>
            <span class="text-sm font-semibold text-gray-800 truncate">{{ row.nombre }} {{ row.apellidos }}</span>
          </div>
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #6b7280; transition: transform 0.2s;"
            [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">expand_more</mat-icon>
        </div>
        <!-- Card Body -->
        <div *ngIf="expandedCardId === i" class="border-t border-gray-100 p-3">
          <div class="grid grid-cols-2 gap-3 text-sm mb-3">
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Documento</span>
              <p class="text-gray-800 font-mono font-medium mt-0.5">{{ row.numeroId }}</p>
            </div>
            <div>
              <span class="text-gray-400 text-xs font-semibold uppercase">Email</span>
              <p class="text-gray-800 font-medium mt-0.5 text-xs break-all">{{ row.email }}</p>
            </div>
          </div>
          <div class="flex gap-2 pt-2 border-t border-gray-100">
            <button type="button" [routerLink]="[path, row.usuarioId, row.email]"
              style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 16px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer;"
              onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">visibility</mat-icon>
              Ver Movimientos
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
